import React, { useEffect, useState } from "react";
import { ModalCore } from "src/Pages/components";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { FormEditarParcela } from "./FormEditarParcela/FormEditarParcela";
import { UseFormEditarParcela } from "./FormEditarParcela/UseFormEditarParcela";

interface IModalEditarParcela {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  installment: any;
  onSave: (values: any) => void;
}

export const ModalEditarParcela = ({
  openModal,
  setOpenModal,
  installment,
  onSave,
}: IModalEditarParcela) => {
  const [values, setValues] = useState<any>(null);

  useEffect(() => {
    if (openModal && installment) {
      // Converter valores para o formato do formulário
      setValues({
        ...installment,
        valorBoleta: FormatMoney(String(installment.valorBoleta)),
        vencimento: installment.vencimento,
      });
    } else {
      setValues(null);
    }
  }, [openModal, installment]);

  const { handleEditarParcela, loading: loadingEditarParcela } =
    UseFormEditarParcela({
      setOpenModal,
      onSave,
      values: values || {},
    });

  if (!values) return null;

  return (
    <ModalCore
      loadingSubmit={loadingEditarParcela}
      open={openModal}
      setOpen={setOpenModal}
      sxStyle={{ width: "600px" }}
      title="Editar parcela"
      titleSubmit="Editar parcela"
      onChange={handleEditarParcela}
    >
      <FormEditarParcela values={values} setValues={setValues} />
    </ModalCore>
  );
};

